import { UserType } from "../../role";

export const SUPER_ROLE = "ROLE_cdoc_admin";
export const HR_SUPER_ROLE = "ROLE_cdoc_hr";
export const INITIATOR_ROLE = "ROLE_cdoc_initiator";
export const EXTERNAL_ROLE = "ROLE_cdoc_external";

export enum userTypes {
    person = "PERSON",
    group = "GROUP",
    all = "ALL"
}

export interface Department {
    id: number;
    level: number;
    name: string;
    type: UserType;
    url: string;
}

export interface UserSearchResult {
    login: string;
    name: string;
    nameEn: string;
    type?: UserType;
    roleId?: number;
    department?: Department | Department['name'];
    departments?: Department[];
}

export interface IUserInfo {
    login: string;
    roles: string[];
    isSuper?: boolean;
    isHrSuper?: boolean;
    isInitiator?: boolean;
    isExternal?: boolean;
    userName?: string;
    userNameEn?: string;
}

export interface IProperty {
    attribute: string;
    value: string;
}

export interface IUsersService {
    loadUserInfo: () => Promise<IUserInfo>;
    loadProperties: () => Promise<IProperty[] | string>;
    cacheDepartments: () => Promise<string>;
}

interface IStaffName {
    first: string;
    last: string;
    middle: string;
}

export interface IStaffGap {
    url: string,
    color: string,
    name: string,
    time: string,
    workflow: string,
    type: string,
    date_from: string | null,
    date_to: string | null
}

export interface IUserStaff {
    url: string,
    title: string,
    login: string,
    name: IStaffName,
    is_dismissed: boolean,
    telegram: string[],
    position: string,
    department_name: string,
    gaps: IStaffGap[],
    gap: IStaffGap,
    work_email: string
}

// export interface IUserStaff {
//     "url": "https://staff.yandex-team.ru/papink",
//     "title": "Kirill Papin",
//     "login": "papink",
//     "name": {
//         "first": "Kirill",
//         "last": "Papin",
//         "middle": ""
//     },
//     "is_dismissed": false,
//     "telegram": [
//         "papin_k"
//     ],
//     "position": "Group Leader",
//     "department_name": "Legal tech team",
//     "gaps": [
//         {
//             "url": "https://staff.yandex-team.ru/gap/8460500",
//             "color": "#abd46e",
//             "name": "business trip",
//             "time": "till 4&nbsp;October",
//             "workflow": "trip",
//             "type": "trip",
//             "date_from": null,
//             "date_to": null
//         }
//     ],
//     "gap": {
//         "url": "https://staff.yandex-team.ru/gap/8460500",
//         "color": "#abd46e",
//         "name": "business trip",
//         "time": "till 4&nbsp;October",
//         "workflow": "trip",
//         "type": "trip",
//         "date_from": null,
//         "date_to": null
//     },
//     "work_email": "papink@yandex-team.ru"
// }
